import { RESET_TO_DEFAULT_LAUNCHER_POSITION } from '../constants/PostMessageTypes';
import { postMessageToParent } from './postMessageToParent';
export const handleResetToDefaultLauncherPosition = () => postMessageToParent(RESET_TO_DEFAULT_LAUNCHER_POSITION, {});